import { useState, useEffect, useCallback, useMemo } from "react";
import { useAuth } from "../../../../hooks"; // Ajusta ruta si es necesario
import { InstitutionDashboardApi } from "../../../../api/revi/institutionDashboardApi";

export function useInstitutionDashboardController() {
  // CORRECCIÓN: Quitamos 'user' para evitar warning no-unused-vars
  const { accessToken } = useAuth();

  const api = useMemo(() => new InstitutionDashboardApi(), []);

  // --- Estados de Filtros ---
  const [timeRange, setTimeRange] = useState("last_30_days");
  // "all" = Global. Si es un ID, filtra por ese terapeuta.
  const [selectedTherapist, setSelectedTherapy] = useState("all");

  // --- Estados de Datos ---
  const [therapistsList, setTherapistsList] = useState([]);
  const [summary, setSummary] = useState(null);
  const [charts, setCharts] = useState({ distribution: [], evolution: [] });
  const [activity, setActivity] = useState([]);

  // --- Estados de UI ---
  const [loading, setLoading] = useState(true);
  const [loadingFilters, setLoadingFilters] = useState(true);
  const [error, setError] = useState("");

  // 1. Cargar lista de Terapeutas (Solo al montar)
  useEffect(() => {
    let mounted = true;
    const fetchList = async () => {
      if (!accessToken) return;
      try {
        setLoadingFilters(true);
        const list = await api.getTherapistsList(accessToken);
        if (mounted) setTherapistsList(list);
      } catch (e) {
        console.error("Error loading therapist list:", e);
      } finally {
        if (mounted) setLoadingFilters(false);
      }
    };
    fetchList();
    return () => {
      mounted = false;
    };
  }, [accessToken, api]);

  // 2. Cargar Dashboard (KPIs, Charts, Activity)
  const loadDashboardData = useCallback(async () => {
    if (!accessToken) return;

    setLoading(true);
    setError("");

    try {
      const filterParams = {
        timeRange,
        // Si es "all", no enviamos therapistId para que el back haga vista global
        therapistId:
          selectedTherapist === "all" ? undefined : selectedTherapist,
      };

      const [summaryRes, chartsRes, activityRes] = await Promise.all([
        api.getSummary(accessToken, filterParams),
        api.getCharts(accessToken, filterParams),
        api.getActivity(accessToken, filterParams),
      ]);

      setSummary(summaryRes?.data || null);
      setCharts(chartsRes?.charts || { distribution: [], evolution: [] });
      setActivity(activityRes?.activity || []);
    } catch (e) {
      console.error(e);
      setError(e?.message || "Error cargando dashboard");
    } finally {
      setLoading(false);
    }
  }, [accessToken, api, timeRange, selectedTherapist]);

  // Recargar cuando cambien filtros
  useEffect(() => {
    loadDashboardData();
  }, [loadDashboardData]);

  return {
    timeRange,
    setTimeRange,
    selectedTherapist,
    setSelectedTherapy,
    therapistsList,
    summary,
    charts,
    activity,
    loading,
    loadingFilters,
    error,
    reload: loadDashboardData,
  };
}
